import { render, staticRenderFns } from "./Invaders.vue?vue&type=template&id=1805b642&scoped=true&"
import script from "./Invaders.vue?vue&type=script&lang=ts&"
export * from "./Invaders.vue?vue&type=script&lang=ts&"
import style0 from "./Invaders.vue?vue&type=style&index=0&id=1805b642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1805b642",
  null
  
)

export default component.exports